var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTemperature = function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a2 2 0 0 0-2 2v6.8A3 3 0 0 0 4 11a3 3 0 0 0 6 0 3 3 0 0 0-1-2.23V2a2 2 0 0 0-2-2Zm0 13a2 2 0 0 1-1-3.71V2a1 1 0 0 1 2 0v.5H7v.75h1V4.5H7v.75h1V6.5H7v.75h1V8.5H7v.75h1A2 2 0 0 1 9 11a2 2 0 0 1-2 2Z"
  })));
};

export default SvgTemperature;